module.exports = __webpack_public_path__ + "img/parc d'attraction.ceb915ac.png";